import { useBestOfferCollection } from '@/hooks/query/useCollectionOffers';
import { convertWeiToEthers } from '@/utils/convertValueToWei';

interface IBestOfferColumnProps {
  collectionSlug: string;
}

function BestOfferColumn({ collectionSlug }: IBestOfferColumnProps) {
  const { data: bestOffer, isLoading: bestOfferLoading } = useBestOfferCollection(collectionSlug);

  return <div className='font-space-mono text-sm pl-8'>{bestOfferLoading ? <div className='loader'></div> : bestOffer ? `${convertWeiToEthers(bestOffer?.price.value)} ETH` : 'N/A'}</div>;
}

export default BestOfferColumn;
